import { useReferentiallyStableRawStorage } from "./use-referentially-stable-raw-storage";

export const useRawLocalStorage = (key: string) => useReferentiallyStableRawStorage(localStorage, key);
